import { fetchServiceOfferings } from "@/lib/api";
import { ServiceOfferingCard } from "@/components/services/ServiceOfferingCard";

export async function ServicesListBlock({ content }: { content: Record<string, unknown> }) {
  const heading = content.heading ? String(content.heading) : "";
  const intro = content.intro ? String(content.intro) : "";
  const category = content.category ? String(content.category) : "";
  const limit = typeof content.limit === "number" ? Math.max(1, Math.min(24, content.limit)) : 12;
  const offerings = await fetchServiceOfferings().catch(() => []);
  const visible = offerings
    .filter((offering) => !category || offering.category.toLowerCase() === category.toLowerCase())
    .slice(0, limit);

  if (visible.length === 0) return null;

  return (
    <section className="mx-auto max-w-6xl px-4 py-10">
      {heading ? (
        <h2 className="mb-3 text-2xl font-bold text-[var(--color-text)]" style={{ fontFamily: "var(--font-heading)" }}>
          {heading}
        </h2>
      ) : null}
      {intro ? <p className="mb-6 max-w-3xl text-[var(--color-secondary)]">{intro}</p> : null}
      <ul className="flex flex-col gap-4">
        {visible.map((offering) => (
          <li key={offering.id}>
            <ServiceOfferingCard offering={offering} />
          </li>
        ))}
      </ul>
    </section>
  );
}
